var initialState = {
    scrollY: {}
};

export default (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case 'SET_SCROLL_Y': {
            const scrollY = { ...state.scrollY };
            scrollY[action.key] = action.value;
            return { ...initialState, scrollY };
        }
        default:
            return state;
    }
};
